import { IconCheckCircleFilled, IconHourglass } from '@iwoca/icons';
import clsx from 'clsx';
import styles from './FundingRequirement.module.css';
import { TDeserialisedFundingRequirement } from './fundingRequirements.helper';

type TProps = {
  requirement: TDeserialisedFundingRequirement;
};

export const FundingRequirement = ({ requirement }: TProps) => {
  const isCompleted = requirement.isCompleted;

  if (!requirement.label) {
    return null;
  }

  return (
    <li
      className={clsx(styles.fundingRequirement, {
        [styles.completed]: isCompleted,
      })}
    >
      {isCompleted ? (
        <IconCheckCircleFilled
          data-testid="complete-icon"
          className={styles.fundingRequirementIcon}
          height={24}
          width={24}
        />
      ) : (
        <IconHourglass
          data-testid="incomplete-icon"
          className={styles.fundingRequirementIcon}
          height={24}
          width={24}
        />
      )}

      {requirement.label}
    </li>
  );
};
